import './ccf-outbound-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfOutboundIconProps {}

/**
 * CcfOutboundIcon used to disply outbound icon in the contact card history panel
 * @param props - CcfOutboundIconProps
 * @example -- <CcfOutboundIcon />
 */
export function CcfOutboundIcon(props: CcfOutboundIconProps) {
  return (
      <SvgIcon {...props}>
        <g id="ic_outbound" clipPath="url(#clip-ic_outbound)">
          <g id="Group_119457" data-name="Group 119457" transform="translate(7 6)">
            <g id="Group_111796" data-name="Group 111796" transform="translate(0 0)">
              <path id="Path_13823" data-name="Path 13823" d="M7.16,0C1.425-.062,0,7.053,0,7.053A8.936,8.936,0,0,1,7.16,3.877c.037,0,.02-1.219,0-2C7.138.979,7.16,0,7.16,0Z" transform="translate(2.277 12) rotate(-90)" fill="#707070"/>
              <path id="Path_13824" data-name="Path 13824" d="M0,1.023V0L5.032,4.122.193,8.373V5.958Z" transform="translate(0 5.032) rotate(-90)" fill="#707070"/>
            </g>
          </g>
        </g>
      </SvgIcon>
  );
}

export default CcfOutboundIcon;
